__turbopack_context__.v({
  "bar": "progress-module__kZCuvG__bar",
  "error": "progress-module__kZCuvG__error",
  "indeterminate": "progress-module__kZCuvG__indeterminate",
  "label": "progress-module__kZCuvG__label",
  "note": "progress-module__kZCuvG__note" + " " + __turbopack_context__.i(85013)["note"],
  "progress": "progress-module__kZCuvG__progress",
  "progressAnimation": "progress-module__kZCuvG__progressAnimation",
  "success": "progress-module__kZCuvG__success",
  "track": "progress-module__kZCuvG__track",
  "warning": "progress-module__kZCuvG__warning",
});
